"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileDetect = exports.isMobileOrTablet = exports.isMobile = void 0;
var _mobileDetect = _interopRequireDefault(require("mobile-detect"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var mobileDetect = new _mobileDetect.default(window.navigator.userAgent);

// Workaround to detect iPads, which by default view desktop versions of sites,
// which makes them appear to be Macs.
// This will only work as long as Macs don't get touchscreens.
exports.mobileDetect = mobileDetect;
var isNewIpad = function isNewIpad() {
  return window.navigator.userAgent.match(/Mac/) && window.navigator.maxTouchPoints > 2;
};

/**
 * This will only return true for a mobile phone; we don't include tablet devices.
 */
var isMobile = function isMobile() {
  return !!mobileDetect.phone();
};
exports.isMobile = isMobile;
var isMobileOrTablet = function isMobileOrTablet() {
  return !!mobileDetect.mobile() || isNewIpad();
};
exports.isMobileOrTablet = isMobileOrTablet;